import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type CrmDrawerType =
  | "create_lead"
  | "create_viewing"
  | "viewing_qa"
  | "helpdesk_view"
  | "helpdesk_edit_view"
  | "crm_view"
  | "crm_edit_view"
  | "deals_view"
  | "deals_edit_view";

interface CrmDrawerState {
  open: boolean;
  type: CrmDrawerType | null;
  id?: string;
}

const initialState: CrmDrawerState = {
  open: false,
  type: null,
  id: undefined,
};

export const drawerSlice = createSlice({
  name: "drawer",
  initialState,
  reducers: {
    setDrawer: (
      state,
      action: PayloadAction<{
        open: boolean;
        type: CrmDrawerType | null;
        id?: string;
      }>
    ) => {
      state.open = action.payload.open;
      state.type = action.payload.type;
      state.id = action.payload.id;
    },
    clearDrawer: (state) => {
      state.open = false;
      state.type = null;
      state.id = undefined;
    },
  },
});

export const { setDrawer, clearDrawer } = drawerSlice.actions;

export default drawerSlice.reducer;
